<template>
  <Modal
    v-model="showModal"
    title="提示"
    :width="50"
  >
    <Alert type="warning" show-icon>存在以下待运营确认账单，请先进行账单运营确认后再重新下载！</Alert>
    <Table max-height="800" :columns="columns" :data="tableData"></Table>
    <div slot="footer">
      <Button type="primary" @click="closeModal">关闭</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columns: [
        {
          title: '账单ID',
          key: 'sheetId'
        },
        {
          title: '服务学校',
          key: 'schoolName'
        },
        {
          title: '账单月份',
          key: 'settleMonth'
        }
      ],
      showModal: false
    };
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  }
};
</script>
<style scoped>

</style>
